import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={40} height={40} viewBox="0 0 40 40" fill="none" {...props}>
      <Circle
        cx={20}
        cy={20}
        r={18}
        fill="#E40046"
        stroke="#fff"
        strokeWidth={4}
      />
      <Path
        d="M12.5 24.548v2.534c0 .233.183.416.417.416h2.533a.391.391 0 00.292-.125l9.1-9.091-3.125-3.126-9.092 9.092a.41.41 0 00-.125.3zm14.758-8.683a.83.83 0 000-1.175l-1.95-1.95a.83.83 0 00-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
